import { Injectable } from '@angular/core';
import { Analytics } from '@services/analytics.service';
import { CurrentUserService } from '@services/current-user.service';
import { environment } from 'src/environments/environment';

import { AnalyticsEvent, AnalyticsEventsService } from '@services/analytics-events.service';
import posthog from 'posthog-js';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PostHogService implements Analytics {
  currentUser$ = this.currentUserService.user$;

  constructor(private currentUserService: CurrentUserService, private events: AnalyticsEventsService) {}

  startTracking() {
    if (environment.postHogKey) {
      this.currentUser$.pipe(first()).subscribe((user) => {
        /// See https://posthog.com/docs/libraries/js/config for more options.
        posthog.init(environment.postHogKey, {
          api_host: 'https://us.i.posthog.com',
          person_profiles: 'identified_only',
          persistence: 'memory',
          autocapture: false,
          capture_pageview: false,
          capture_pageleave: false,
          capture_dead_clicks: false,
          bootstrap: {
            distinctID: user.gid
          }
        });
      });

      this.events.events$.subscribe(this.handleAnalyticsEvent);
    }
  }

  handleAnalyticsEvent = (event: AnalyticsEvent) => {
    const properties = event.eventProperties || {};

    posthog.capture(event.eventType, properties);
  };
}
